// 定数はこのファイルへ
export default Object.freeze({})

// 詳細ページのヘッダー動作モード
export const DETAIL_VIEW_HEADER_MODE = {
  BACK: 'back', // 戻るボタンを表示
  CLOSE: 'close', // 閉じるボタンを表示
  NONE: 'none', // 何も表示しない（戻る・閉じるを許可せずページ内で特定のページへ遷移させる場合に使用）
}

// SystemDialogコンポーネントのモード
export const SYSTEM_DIALOG_MODE = {
  CLOSE: 'CLOSE', // 閉じるボタンのみ
  YES: 'YES', // YESボタンのみ
  YES_NO: 'YES_NO',
  YES_CANCEL: 'YES_CANCEL',
  YES_NO_CANCEL: 'YES_NO_CANCEL',
  NO_OK: 'NO_OK',
}

// 申請ダイアログのモード
export const REQUEST_DIALOG_MODE = {
  PAID_VACATION: 'PAID_VACATION', // 有休
  LEGAL_OUT_WORK: 'LEGAL_OUT_WORK', // 時間外勤務
}

// システムメッセージ
export const SYSTEM_MESSAGE = {
  NETWORK_ERROR: 'ネットワークに接続できません。</br>ネットワーク接続を確認し、再度お試しください',
  UNAUTHORIZED: '認証に失敗しました',
  ATTENDANCE_EXISTS: 'すでに打刻されていますが再度打刻しますか？'
}

export const DAY_OF_WEEK = ['日', '月', '火', '水', '木', '金', '土'];

export const APP_MODE = {
  KINTAI: 'kintai',
  JINJI: 'jinji'
}